import React from 'react';
import Filter, { FilterModal, FilterSection } from './Filter';
import LocationFilterComponent from './FilterComponents/LocationFilter';

import styles from '../search.scss';

const LocationFilter = (props) => {
    const { type = '', clearFilters, filters, filterInputs, handleFilterClick, filterModal, closeModals, applyLocationFilter, geocoded, handleLocationChange, handleLocationSelect, handleCurrentLocationClick, handleDistanceChange, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    const locationFilterProps = {
        clearFilters,
        value: filterInputs.locationInputValue,
        geoLocation: geocoded,
        handleLocationChange,
        handleLocationSelect,
        handleCurrentLocationClick,
        distance: filterInputs.distance,
        handleDistanceChange,
    };

    const locationText = type === 'collegeCorner' ? 'All locations' : 'Location';
    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'location'}
                handleFilterClick={handleFilterClick}
                isActive={(filters.location && filters.lat && filters.lng && filters.distance) || (filters.locationCountryName || filters.locationStateName) || filterModal === 'location'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                searchFor={type}
                data-testid={dataTestId}
            >
                {

                    // eslint-disable-next-line no-nested-ternary
                    filters.locationCountryName ? (filters.locationStateName ? `In ${filters.locationStateName}, ${filters.locationCountryName}` : `In ${filters.locationCountryName}`)
                        : filters.location && filters.lat && filters.lng && filters.distance ? `Near ${filters.location}` : locationText
                }
            </Filter>
            {filterModal === 'location' && (
                <FilterModal
                    title={'Location'}
                    onCloseClick={closeModals}
                    clearFilters={() => clearFilters('location', true)}
                    handleFilterSubmit={applyLocationFilter}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <LocationFilterComponent {...locationFilterProps} data-testid={dataTestId} />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

export default LocationFilter;
